import { INumberRangeAlertBehavior, INumberRangeAlertBehaviorSpecifiable, IThresholdAlertBehavior } from "../../../../../../../documaker/domain/format/objects";
import { IObjectBeanNumberTextDrawable } from "../../../beans/objects";
import { FloatTranslator, ColorCodeTranslator } from "../../values";

export class NumberRangeAlertBehaviorTranslator {
  from(bean: IObjectBeanNumberTextDrawable): INumberRangeAlertBehavior {
    return {
      upper: this.thresholdAlert.from(bean["@high-value"], bean["@high-over-color"]),
      lower: this.thresholdAlert.from(bean["@low-value"], bean["@low-over-color"]),
    };
  }

  to(object: INumberRangeAlertBehaviorSpecifiable) {
    const high = this.thresholdAlert.to(object.numberRangeAlertBehavior.upper);
    const low = this.thresholdAlert.to(object.numberRangeAlertBehavior.lower);
    return {
      highValue: high.value,
      highOverColor: high.color,
      lowValue: low.value,
      lowOverColor: low.color,
    };
  }

  private readonly thresholdAlert = {
    from: (value: string, color: string) => {
      const isEnable = ((value !== undefined) && (value !== null));
      const shouldAlertByStyle = ((color !== undefined) && (color !== null));
      return {
        isEnable,
        threshold: isEnable ? this.float.from(value) : 0,
        alertByStyle: {
          isEnable: shouldAlertByStyle,
          color: {
            value: this.colorCode.from(color),
          },
        },
      };
    },
    to: (object: IThresholdAlertBehavior) => ({
      value: object.isEnable ? this.float.to(object.threshold) : undefined,
      color: (object.isEnable && object.alertByStyle.isEnable) ? this.colorCode.to(object.alertByStyle.color.value) : undefined,
    }),
  };
 
  private readonly float = new FloatTranslator();
  private readonly colorCode = new ColorCodeTranslator();
}
